<script>
  import ButtonBookACall from './lib/ButtonBookACall.svelte';
  import Card from './lib/Card.svelte';
  import ContactCard from './lib/ContactCard.svelte';
  import Logo from './lib/Logo.svelte';
</script>

<div class="custom-font max-w-screen-lg mx-auto">
  <div class="header flex justify-between ">
    <div class="flex items-center space-x-4">
      <Logo/>
      <h1 style="font-size: 20px; font-weight: 500; line-height: 28px; letter-spacing: -0.01em; text-align: left;">Infinitro</h1>
    </div>
    <div class="flex-shrink-0 "> 
      <ButtonBookACall></ButtonBookACall>
    </div>
  </div>

  <h2 class="text-center text-3xl md:text-4xl lg:text-5xl font-bold py-4 md:py-6 lg:py-8"
    style="width: 100%; font-weight: 500; line-height: 1.4; letter-spacing: -0.012em; text-align: left; color: #2E2E2E;">
    Infinitro: leading global technical software development
  </h2>

  <h2 class="text-center text-2xl md:text-4xl font-bold mb-4 md:mb-6 lg:mb-8"
    style="width: 100%; height: auto; gap: 0px; font-size: 16px; font-weight: 400; line-height: 24px; text-align: left; color: #737373;">
    Infinitro excels in delivering cutting-edge global support services to a diverse array of
    international organizations, focusing on optimizing operational efficiencies so clients can
    concentrate on their core business functions.
  </h2>


  <div class="mb-30">
    <ButtonBookACall></ButtonBookACall>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-screen-lg mx-auto">
    <Card
      title="Business Solution"
      description="Whether you’re embarking on new projects, tackling scaling issues, or modernizing legacy systems, our expert guidance ensures your business is on the path to growth. Make informed technical decisions, validated by user feedback, to future-proof your solutions before development begins."
      images={['./icons/bussinessSolutions.svg']}
    />

    <Card
      title="Team-based Collaboration"
      description="Work closely with our expert teams to expedite your software transformation and elevate your success through consistently transparent partnerships."
      images={['./icons/team.svg']}
    />

    <Card
      title="Problem-Solving"
      description="Expand, update, and transform your platform with expert guidance and state-of-the-art technologies."
      images={['./icons/problem.svg']}
    />

    <Card
      title="Software Development"
      description="By making strategic decisions regarding organization, components, interfaces, and technologies, you can align your software with your business objectives, integrate new technologies as they emerge, future-proof your software ecosystem, and enhance overall performance across your business."
      images={['../icons/code.svg']}
    />

    <Card
      title="Ecommerce & Payment Infrastructure"
      description="Enhance conversion rates with built-in optimizations and over 100 payment methods.Offer seamless one-click checkout experiences and unify online and in-person payments for a smooth customer journey. Quickly launch payment methods and present them in local currencies to accelerate market expansion. Sell across borders to many countries, reducing the costs associated with multicurrency management. Save time and engineering resources through enhanced developer productivity. Ensure leading reliability to avoid downtime and reduce costs."
      images={['../icons/ecomerce.svg']}
    />

    <Card
      title="Consulting & Support"
      description="Our hosted consulting and support solutions leverage open-source technology to offer the same capabilities and features as traditional proprietary platforms, but at a significantly lower cost. Our virtual support offerings are designed to scale flexibly with your business needs. They enable you to efficiently and affordably expand your team by swiftly adding new users and enhancing their productivity through straightforward access to the full suite of features and functionalities."
      images={['../icons/consulting.svg']}
    />

    <Card
      title="Marketing Solutions"
      description="Keeping your clients in the loop and broadening your client base through structured and strategic marketing tools. Social media marketing and targeted marketing products are our speciality and we will use these to increase your revenue and online reputation"
      images={['../icons/marketing.svg']}
    />

    <Card
      title="SEO, and Reputation Management"
      description="Infinitro's search engine optimization services drive high-quality traffic to your website using targeted keywords and phrases designed to enhance conversion rates."
      images={['../icons/seoReputation.svg']}
    />
  </div>  

  <div class="mb-30" style="margin-top: 30px;">
    <ContactCard></ContactCard>
  </div>
  
  <div class="mb-30">
    <h2 class="text-center font-bold" styles="height: 16px;  gap: 0px;  font-size: 16px;  font-weight: 500;  line-height: 24px;  text-align: center;  color: #2E2E2E;  margin-bottom: 10px;">
      Infinitro Ltd:
    </h2>
    <h2 class="text-center" styles="height: 32px;  gap: 0px;  font-size: 14px;  font-weight: 400;  line-height: 16px;  text-align: center;  color: #737373;  margin-bottom: 10px;">
      Company No HE 396960
    </h2>
  </div>
  <div class="mb-30" style="padding-bottom: 30px;">
    <h2 class="text-center font-bold"  styles="height: 16px;  gap: 0px;  font-size: 16px;  font-weight: 500;  line-height: 24px;  text-align: center;  color: #2E2E2E;  margin-bottom: 10px;">
      Enquiries
    </h2>
    <h2 class="text-center" style="height: 32px; gap: 0px; font-size: 14px; font-weight: 400; line-height: 16px; text-align: center; color: #737373; margin-bottom: 10px;">
      <a href="mailto:admin@infinitro.tech" style="color: #737373; text-decoration: underline;">
        admin@infinitro.tech
      </a>
    </h2>
  </div>
</div>

